/*!
 * Copyright (c) 2015-present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * 
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { closeSession, sessionExists, getSession, refreshSession, setCookieAndRedirect } from './api.js';

function createSessionApi(sdk) {
    const session = {
        close: closeSession.bind(null, sdk),
        exists: sessionExists.bind(null, sdk),
        get: getSession.bind(null, sdk),
        refresh: refreshSession.bind(null, sdk),
        setCookieAndRedirect: setCookieAndRedirect.bind(null, sdk)
    };
    return session;
}

export { createSessionApi };
//# sourceMappingURL=factory.js.map
